import { render, staticRenderFns } from "./EligibilitySplitWrapper.vue?vue&type=template&id=135707f4"
import script from "./EligibilitySplitWrapper.vue?vue&type=script&lang=js"
export * from "./EligibilitySplitWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports